export const UPDATE_METERLIST_LIST_BEGIN = 'UPDATE_METERLIST_LIST_BEGIN';
export const UPDATE_METERLIST_LIST_SUCCESS = 'UPDATE_METERLIST_LIST_SUCCESS';
export const UPDATE_METERLIST_STATUS_SUCCESS = 'UPDATE_METERLIST_STATUS_SUCCESS';
export const UPDATE_METERLIST_CITY_SUCCESS = 'UPDATE_METERLIST_CITY_SUCCESS';
export const UPDATE_METERLIST_DIST_SUCCESS = 'UPDATE_METERLIST_DIST_SUCCESS';
export const UPDATE_METERLIST_BANK_SUCCESS = 'UPDATE_METERLIST_BANK_SUCCESS';
export const UPDATE_METERLIST_USAGEDESC_SUCCESS = 'UPDATE_METERLIST_USAGEDESC_SUCCESS';
export const UPDATE_METERLIST_TABLEDATA_SUCCESS = 'UPDATE_METERLIST_TABLEDATA_SUCCESS';
